import { render, staticRenderFns } from "./CmgLostBagModal.vue?vue&type=template&id=815e3260&scoped=true&lang=pug"
import script from "./cmg-lost-bag-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-lost-bag-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLostBagModal.vue?vue&type=style&index=0&id=815e3260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815e3260",
  null
  
)

export default component.exports